import React from "react";

// reactstrap components
import {
    Alert,
    Table,
    Card,
    CardHeader,
    Col,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Container,
    Row,
    CardBody,
} from "reactstrap";
// core components
import ReactDatetime from "react-datetime";
import * as moment from "moment";
import StockReports from "components/Tables/StockReport";
import Header from "components/Headers/StockReportHeader";
import InventoryDataService from "../../services/InventoryDataService";
import WarehouseDataService from "../../services/WarehouseDataService";

class StockReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reports: [],
            perPage: 10,
            currentPage: 1,
            selectedProduct: undefined,
        };
        this.inventoryDataService = new InventoryDataService();
        this.warehouseDataService = new WarehouseDataService();
    }

    async componentDidMount() {
        // this.fetchData()
        this.getWarehouses()
    }

     getWarehouses() {
        this.warehouseDataService.getList(1, 99999, null)
        .then((data) => {
            return {
            warehouses: data.data.warehouse_list !== null && data.data.errorMessage === undefined ? data.data.warehouse_list : [],
            };
        })
        .then((res) => this.setState({ warehouses: res.warehouses }));
        setTimeout(() => {
        this.setState({ errorMessage: undefined });
        }, 5000);
    }  

    onDateChanged(e, dateFieldType) {
        var date = new Date(e._d);
        if (dateFieldType === 'endDate') {
            date.setHours(23, 59, 59, 59);
        }
        this.setState({
            [dateFieldType]: moment(date.toISOString(), 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD'),
            currentPage: 1,
        }, () => this.fetchData(this.state.keyword));
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (e.target.name === 'barcode' && (e.target.value !== undefined && e.target.value !== '')) {
                this.handleSearch(e.target.value)
            }
        }
    }

    fetchData(keyword) {
        this.setState({ errorMessage: undefined, warningMessage: undefined });
        const { currentPage, startDate, endDate, perPage, warehouseId } = this.state;

        if ([keyword, startDate, endDate].some(v => v === undefined || v === '')) {
            this.setState({ warningMessage: 'Barcode dan semua tanggal harus diisi terlebih dahulu' });
            return;
        }

        this.inventoryDataService.getStockReports(keyword, warehouseId, startDate, endDate, currentPage, perPage)
            .then(res => {
                if (!res?.data || res?.data === null) {
                    this.setState({
                        warningMessage: 'Data yang anda cari tidak ditemukan',
                        reports: [],
                    });
                    return;
                }

                if (res?.data?.errorMessage) {
                    this.setState({ errorMessage: res.data.errorMessage });
                } else {
                    const reports = Array.isArray(res.data) ? res.data : [];
                    this.setState({ reports });
                }
            });
    }

    handlePageClick = (e) => {
        const selectedPage = e;

        this.setState({
            currentPage: selectedPage,
        }, () => {
            this.fetchData(this.state.keyword)
        });
    }

    handleNextPageClick() {
        this.handlePageClick(this.state.currentPage + 1)
    }

    handlePreviousPageClick() {
        this.handlePageClick(this.state.currentPage - 1)
    }

    handleChangeSearchId(e) {
        this.setState({ searchId: e.target.value });
    }

    handleSearch = (keyword) => {
        this.setState({
            currentPage: keyword !== undefined && keyword !== '' ? 1 : this.state.currentPage,
            keyword: keyword,
            warehouse: null
        }, () => {
            this.fetchData(keyword);
        });
    }

    onChange = (e) => {
        const keyword = e.target.value;
        this.setState({ keyword: keyword })
    }

    handleSearchByWarehouseId(e) {
        const value = e.target.value;
        const warehouseId = value === null ? null : parseInt(value, 10);

        this.setState({ warehouseId }, () => {
            if (this.state.keyword) {
                this.fetchData(this.state.keyword);
            }
        });
    }

    render() {
        return (
            <>
                <Header />
                {/* Page content */}
                <Container className="mt--7" fluid>
                    {/* Table */}
                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <Col className="text-right" xs="4">
                                        </Col>
                                        {this.state.errorMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="danger">
                                                    <b>Internal Server Error</b>: {this.state.errorMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                        {this.state.warningMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="warning">
                                                    {this.state.warningMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                        {this.state.successMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="success">
                                                    {this.state.successMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12}>
                                            <Row>
                                                <Col xs={3}>
                                                    <InputGroup className="input-group-alternative">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ni ni-zoom-split-in" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Warehouse"
                                                            name="warehouse"
                                                            type="select"
                                                            value={this.state.warehouseId !== null ? this.state.warehouseId : "-1"}
                                                            onChange={this.handleSearchByWarehouseId.bind(this)}
                                                        >
                                                            <option value='-1'>Semua warehouses</option>
                                                            <option value='0'>Produk tanpa warehouse</option>
                                                            {this.state.warehouses?.map(warehouse => (
                                                                <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                                                                    {warehouse.warehouse_name}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </InputGroup>
                                                </Col>
                                                <Col xs={3}>
                                                    <InputGroup className="input-group-alternative">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ni ni-zoom-split-in" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            className="form-control-alternative"
                                                            placeholder="Search dengan Barcode"
                                                            name="product_barcode"
                                                            onChange={(e) => this.onChange(e)}
                                                            onKeyUp={this.onKeyUp.bind(this)}
                                                            type="text"
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col xs={3}>
                                                    <FormGroup>
                                                        <InputGroup className="input-group-alternative">
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="ni ni-calendar-grid-58" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <ReactDatetime
                                                                inputProps={{
                                                                    placeholder: "Dari tanggal"
                                                                }}
                                                                range="start"
                                                                timeFormat={false}
                                                                renderDay={(props, currentDate, selectedDate) => {
                                                                    let classes = props.className;
                                                                    if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        this.state.startDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " start-date";
                                                                    } else if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        new Date(this.state.startDate._d + "") <
                                                                        new Date(currentDate._d + "") &&
                                                                        new Date(this.state.endDate._d + "") >
                                                                        new Date(currentDate._d + "")
                                                                    ) {
                                                                        classes += " middle-date";
                                                                    } else if (
                                                                        this.state.endDate &&
                                                                        this.state.endDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " end-date";
                                                                    }
                                                                    return (
                                                                        <td {...props} className={classes}>
                                                                            {currentDate.date()}
                                                                        </td>
                                                                    );
                                                                }}
                                                                onChange={(e) => this.onDateChanged(e, "startDate")}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={3}>
                                                    <FormGroup>
                                                        <InputGroup className="input-group-alternative">
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="ni ni-calendar-grid-58" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <ReactDatetime
                                                                inputProps={{
                                                                    placeholder: "Hingga tanggal"
                                                                }}
                                                                range="end"
                                                                timeFormat={false}
                                                                value={this.state.endDate}
                                                                renderDay={(props, currentDate, selectedDate) => {
                                                                    let classes = props.className;
                                                                    if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        this.state.startDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " start-date";
                                                                    } else if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        new Date(this.state.startDate._d + "") <
                                                                        new Date(currentDate._d + "") &&
                                                                        new Date(this.state.endDate._d + "") >
                                                                        new Date(currentDate._d + "")
                                                                    ) {
                                                                        classes += " middle-date";
                                                                    } else if (
                                                                        this.state.endDate &&
                                                                        this.state.endDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " end-date";
                                                                    }
                                                                    return (
                                                                        <td {...props} className={classes}>
                                                                            {currentDate.date()}
                                                                        </td>
                                                                    );
                                                                }}
                                                                onChange={(e) => this.onDateChanged(e, "endDate")}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                {this.state.reports.length > 0 && (
                                    <CardBody>
                                        <div>
                                            <h6 className="heading-small text-muted mb-4">
                                                Informasi produk
                                            </h6>
                                            <div className="pl-lg-4">
                                                <Table className="align-items-center table-flush table-borderless" responsive>
                                                    <tbody>
                                                        <tr>
                                                            <th>Nama produk</th>
                                                            <td>{this.state.reports?.[0]?.product_name}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Barcode produk</th>
                                                            <td>{this.state.keyword}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Jumlah  Stok</th>
                                                            <td>{this.state.reports?.[0]?.total_stock}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                            <hr className="my-4" />
                                        </div>
                                        <h6 className="heading-small text-muted mb-4">
                                            Riwayat Stok
                                        </h6>
                                        {this.state.reports?.length > 0 && (
                                            <StockReports
                                                items={this.state.reports}
                                                fetchData={this.fetchData.bind(this)}
                                                isLunasi={false}
                                            />
                                        )}
                                        {this.state.reports?.length === 0 && (
                                            <span>Tidak ada data</span>
                                        )}
                                    </CardBody>
                                )}
                                {this.state.reports?.length > 0 && (<CardFooter className="py-4">
                                    <nav aria-label="...">
                                        <Pagination
                                            className="pagination justify-content-end mb-0"
                                            listClassName="justify-content-end mb-0"
                                        >
                                            <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                                                <PaginationLink
                                                    onClick={() => this.handlePreviousPageClick()}
                                                    tabIndex="-1"
                                                >
                                                    <i className="fas fa-angle-left" />
                                                    <span className="sr-only">Previous</span>
                                                </PaginationLink>
                                            </PaginationItem>
                                            <PaginationItem className={(this.state.perPage > this.state.reports?.length) && "disabled"}>
                                                <PaginationLink
                                                    onClick={() => this.handleNextPageClick()}
                                                >
                                                    <i className="fas fa-angle-right" />
                                                    <span className="sr-only">Next</span>
                                                </PaginationLink>
                                            </PaginationItem>
                                        </Pagination>
                                    </nav>
                                </CardFooter>)}
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

export default StockReport;
